<template>
  <b-card
    border-variant="primary" header-bg-variant="primary" header-text-variant="white"
    header-class="p-3 font-size-lg font-weight-bold"
    header="Pre-Post Trust Checks"
  >
    <table class="table table-sm table-bordered mb-0">
      <tr v-for="(check, index) in checks" :key="index">
        <td width="6%" class="text-center align-middle">
          <i v-if="check.pass" class="fa fa-check-circle text-success font-size-h4"></i>
          <i v-else class="fa fa-times-circle text-danger font-size-h4"></i>
        </td>
        <td width="94%">
          <div class="font-weight-bold" :class="check.pass ? 'text-dark' : 'text-danger'">
            {{ check.label }}
            <b-badge :variant="check.pass ? 'success' : 'danger'" class="ml-2">
              {{ check.pass ? 'PASS' : 'FAIL' }}
            </b-badge>
          </div>
          <div class="font-size-sm text-muted">{{ check.detail }}</div>
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
export default {
  name: "TrustChecklist",

  props: {
    trusts: {
      type: Object,
      required: true
    }
  },

  computed: {
    checks: function() {
      const checks = [
        {
          label: "INSIGHT valid",
          pass: this.trusts.insightValid.pass,
          detail: this.trusts.insightValid.detail
        },
        {
          label: "Reconciled to source",
          pass: this.trusts.reconciled.pass,
          detail: this.trusts.reconciled.detail
        },
        {
          label: "Split integrity",
          pass: this.trusts.splitIntegrity.pass,
          detail: this.trusts.splitIntegrity.detail
        }
      ];
      if (this.trusts.statePremium) {
        checks.push({
          label: "State premium",
          pass: this.trusts.statePremium.pass,
          detail: this.trusts.statePremium.detail
        });
      }
      if (this.trusts.vehicleAllocation) {
        checks.push({
          label: "Vehicle class by state",
          pass: this.trusts.vehicleAllocation.pass,
          detail: this.trusts.vehicleAllocation.detail
        });
      }
      return checks;
    }
  }
};
</script>
